import { useLocation, Navigate, Outlet } from 'react-router-dom';
import { Page } from '../../../../../components/page/page';
import { Tabs, TabType } from '../../../../../components/tabs/tabs';
import { ProfilePath } from '../../../../../routes/manager/manager-enums';
import s from './profile.module.css';
import { useProfile } from './use-profile';
import { Card } from '../../../../../components/card/card';
import { Avatar } from '../../../../../components/avatar/avatar';
import { Loader } from '../../../../../components/loader/loader';
import { adminRecord } from '../company-settings/company-admins/helpers';

const tabs: TabType[] = [
  { id: '1', label: 'Личные данные', href: ProfilePath.Personal },
  // { id: '2', label: 'Социальные сети', href: ProfilePath.Socials },
  { id: '3', label: 'Безопасность', href: ProfilePath.Security },
  { id: '4', label: 'Настройки', href: ProfilePath.Settings },
];

export const Profile = () => {
  const { t, name, email, isLoadingFetch, role } = useProfile();

  const tab = useLocation().pathname.split('/').pop();

  const selectedTab = tabs.find((item) => item.href === tab);

  if (!selectedTab) {
    return <Navigate to={ProfilePath.Personal} replace />;
  }

  return (
    <Page className={s.page}>
      <h2 className={s.title}>{t('Профиль')}</h2>
      <div className={s.content}>
        <div className={s.col1}>
          <Card className={s.base}>
            <div className={s.avatar}>
              {isLoadingFetch ? <Loader /> : <Avatar size="md" name={name} color="#ffd599" />}
              <label className={s.name}>{isLoadingFetch ? <Loader /> : name}</label>
            </div>

            <ul className={s.list}>
              <li className={s.item}>
                <label>{t('Должность')}</label>
                {role && <span>{t(adminRecord[role])}</span>}
              </li>
              <li className={s.item}>
                <label>{t('E-mail')}</label>
                <span>{isLoadingFetch ? <Loader /> : email}</span>
              </li>
            </ul>
          </Card>
        </div>
        <Card className={s.col2}>
          <Tabs
            tabs={tabs.map((item) => ({ ...item, label: t(item.label) }))}
            activeTab={selectedTab}
          />
          <Outlet />
        </Card>
      </div>
    </Page>
  );
};
